import { render, staticRenderFns } from "./TabServicios.vue?vue&type=template&id=08a01c97"
import script from "./TabServicios.vue?vue&type=script&lang=js"
export * from "./TabServicios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports